/**
 * Environment configuration.
 *
 * Values are injected at build time from VITE_* variables in the committed
 * .env.<mode> files. Nothing here is a secret: this is a static
 * front end, so anything in this file ships to the browser and is readable by
 * anyone. Tokens and connection strings must never be added here.
 */

type EnvKey = Extract<keyof ImportMetaEnv, `VITE_${string}`>;

const read = (name: EnvKey, fallback: string): string => {
    const value = import.meta.env[name];
    if (!value) {
        console.warn(`Missing environment variable ${name}; using "${fallback}"`);
        return fallback;
    }
    return value;
};

export const env = {
    sharedApiBaseUrl: read("VITE_SHARED_API_BASE_URL", "/platform/v1"),
    cmmsApiBaseUrl: read("VITE_CMMS_API_BASE_URL", "/cmms/v1"),

    cognito: {
        authority: read("VITE_COGNITO_AUTHORITY", ""),
        clientId: read("VITE_COGNITO_CLIENT_ID", ""),
    },
} as const;
